import type { IPartyCalendarLegendProps } from './IPartyCalendarLegendProps';
import { partyColors } from './partyColors';

/**
 * Легенда календаря (прототип v4 pcLegend): чипи-перемикачі 28px лише типів з подіями — крапка кольору типу, назва, кількість подій
 * (приглушено). Увімкнений — фон і текст відтінку типу, вимкнений — прозорий фон і приглушений текст; aria-pressed.
 */
export function PartyCalendarLegend({ types, counts, off, onToggle }: IPartyCalendarLegendProps) {
  return (
    <div className="pcal__legend">
      {types.filter((type) => (counts[type.key] ?? 0) > 0).map((type) => {
        const c = partyColors(type.hue);
        const on = !off[type.key];
        return (
          <button key={type.key} type="button" className="pcal__chip" aria-pressed={on} onClick={() => onToggle(type.key)}
            style={{ background: on ? c.bg : 'transparent', color: on ? c.fg : 'var(--muted)' }}>
            <span className="pcal__dot" style={{ background: c.dot }} />
            {type.label}
            <span className="pcal__n">{counts[type.key]}</span>
          </button>
        );
      })}
    </div>
  );
}
